import BackgroundOne from '../assets/sidebackgroundOne.jpg';
import BackgroundTwo from '../assets/sidebackgroundTwo.jpg';
import BackgroundThree from '../assets/promoheroThree.png';



export const promoBackgroundOne = {
    background:BackgroundOne,
    title:'todas as promoções',
    btnText:'aproveite'
}

export const promoBackgroundTwo = {
    background:BackgroundTwo,
    title:'Organização de Casa',
    btnText:'ver coleção'
}

export const promoBackgroundThree ={
    background:BackgroundThree,
    btnText:'As nossas marcas'

}